import { Paper, Group, Box, Text, Button, Flex } from "@mantine/core";

interface InfoBannerProps {
  icon?: React.ComponentType<{ size?: number; color?: string }>;
  iconSize?: number;
  iconColor?: string;
  title: string;
  subtitle: string;
  bgColor?: string;
  borderColor?: string;
  titleColor?: string;
  subtitleColor?: string;
  actionLabel?: string;
  onAction?: () => void;
  rightSection?: React.ReactNode;
}

export default function InfoBanner({
  icon: Icon,
  iconSize = 28,
  iconColor = "var(--mantine-color-primary-6)",
  title,
  subtitle,
  bgColor = "primary.0",
  borderColor = "var(--mantine-color-primary-2)",
  titleColor = "black",
  subtitleColor = "gray",
  actionLabel,
  onAction,
  rightSection,
}: InfoBannerProps) {
  return (
    <Paper
      p="md"
      pb="lg"
      radius="lg"
      bg={bgColor}
      style={{
        border: `1px solid ${borderColor}`,
      }}
    >
      <Flex justify="space-between" align="center" gap="md" wrap="wrap">
        <Group gap="xs" align="flex-start" style={{ flex: 1 }}>
          {Icon && <Icon size={iconSize} color={iconColor} />}
          <Box style={{ flex: 1 }}>
            <Text fw={400} size="sm" c={titleColor}>
              {title}
            </Text>
            <Text size="sm" fz={13} c={subtitleColor}>
              {subtitle}
            </Text>
          </Box>
        </Group>
        {rightSection ?? null}
        {!rightSection && actionLabel && onAction && (
          <Button size="xs" onClick={onAction} style={{ whiteSpace: "nowrap" }}>
            {actionLabel}
          </Button>
        )}
      </Flex>
    </Paper>
  );
}
